module.exports = __webpack_public_path__ + "img/68049F_C90DE6_A404CF_B304DC-256px.bcca6e9d.png";